module.exports = __webpack_public_path__ + "static/media/user.5bb03768.avif";